

import {NgModule, ModuleWithProviders} from "@angular/core";
import {CommonModule} from "@angular/common";
import {LoginInfoComponent} from "./login-info/login-info.component";
import { LogoutComponent } from "./logout/logout.component";
import { AuthService } from "../services/auth.service";
import { ConfigService } from "../utils/config.service";
@NgModule({
  imports: [CommonModule],
  declarations: [LoginInfoComponent, LogoutComponent],
  exports: [LoginInfoComponent, LogoutComponent],
  providers: [AuthService,ConfigService]
})
export class UserModule{}
